import React, { useState, useEffect } from "react";
import styled from "styled-components";
import gql from "graphql-tag";
import { connect } from 'react-redux'
import actions from './../../actions/'

import { Container, Row, Col } from "reactstrap";
import AddressBox from "../Checkout/CheckoutAddress/AddressBox";
import FlatButton from "../commons/FlatButton";
import RaisedButton from "../commons/RaisedButton";
import { SubscriptionItem } from "../Subscriptions/SubscriptionItem/SubscriptionItem";
import AddressEditForm from "../Checkout/CheckoutAddress/AddressEditForm"


const SAVE_NEW_ADDRESS = gql`
  mutation SaveAddress($input: AddressInput!) {
    customerAddressCreate(input: $input) {
      errors {
        field
        message
      }
      address {
        id
        firstName
        lastName
        streetAddress1
        streetAddress2
        city
        cityArea
        postalCode
        country {
          country
          code
        }
        countryArea
        phone
      }
    }
  }
`;

const UPDATE_PERSONAL_DETAILS = gql`
  mutation UpdatePersonalDetails($id: ID!, $input: CustomerInput!) {
    customerUpdate(id: $id, input: $input) {
      errors {
        message
      }
      user {
        firstName
        lastName
        email
      }
    }
  }
`;

const TRIGGER_PASSWORD_RESET = gql(`
  mutation TriggerPasswordReset($email: String!) {
    customerPasswordReset(input: {email: $email}) {
      errors {
        message 
      }
    }
  }
`);

const Profile = ({
  children,
  value,
  index,
  client,
  addNewAddress,
  id,
  addresses,
  firstName,
  lastName,
  email,
  updateUserName,
  updateUserEmail,
  logoutUser,
  subscriptions,
  successNotification,
  errorNotification,
}) => {
  
  const [editingName, setEditingName] = useState(false);
  const [firstNameInputValue, setFirstNameInputValue] = useState(firstName);
  const [lastNameInputValue, setLastNameInputValue] = useState(lastName);
  const [editingAddress, setEditingAddress] = useState(false);

  const [editingEmail, setEditingEmail] = useState(false);
  const [emailInputValue, setEmailInputValue] = useState(email);

  useEffect(() => {
    setFirstNameInputValue(firstName);
  }, [firstName]);

  useEffect(() => {
    setLastNameInputValue(lastName);
  }, [lastName]);

  useEffect(() => {
    setEmailInputValue(email);
  }, [email]);

  const saveAddress = newAddress => {
    return client
      .mutate({
        mutation: SAVE_NEW_ADDRESS,
        variables: {
          input: newAddress
        }
      })
      .then(({ data: { customerAddressCreate: { address, errors } ={} }={} }) => {
        if (errors && errors.length > 0) {
          errorNotification("Oops! Something went wrong. Please try again.");
          return false;
        }
        successNotification("Address saved successfully!");
        addNewAddress(address);
        return address;
      });
  };

  const updatePersonalDetails = details => {
    return client
      .mutate({
        mutation: UPDATE_PERSONAL_DETAILS,
        variables: {
          id: id,
          input: details
        }
      })
      .then(({ data: { customerUpdate: { user, errors } = {} } = {} } = {}) => {
        if (errors && errors.length > 0) {
          alert("Oops! Something went wrong. Please try again.");
          return false;
        }
        updateUserEmail(user);
        updateUserName(user);
        setEditingEmail(false);
        setEditingName(false);
        return user;
      });
  };

  const triggerPasswordReset = () => {
    client.mutate({
      mutation: TRIGGER_PASSWORD_RESET,
      variables: {
        email: emailInputValue
      }
    }).then(res => {
      // Toast message
      successNotification(`An email to reset password has been sent to ${emailInputValue}`)
      // Logout user
      logoutUser();
    })
  }

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
    >
      <Container className="mb-5">
      <h4>MY ACCOUNT</h4>
        <hr />
        <Row>
          {/* FIRST & LAST NAME */}
          <div className="col-12 col-lg-4 mb-3">
            <p style={{fontSize: 22}}>
              {firstName}&nbsp;{lastName}&nbsp;
              <FlatButton
                className="mx-3 d-inline"
                onClick={() => setEditingName(!editingName)}
              >
                EDIT
              </FlatButton>
            </p>
            <div hidden={!editingName}>
              <label htmlFor="first-name">First Name</label>
              <input
                name="first-name"
                className="form-control mb-3"
                type="text"
                value={firstNameInputValue}
                onChange={event => setFirstNameInputValue(event.target.value)}
              />
              <label htmlFor="last-name">Last Name</label>
              <input
                name="last-name"
                className="form-control mb-3"
                type="text"
                value={lastNameInputValue}
                onChange={event => setLastNameInputValue(event.target.value)}
              />
              <RaisedButton
              className="btn-hover"
                onClick={() =>
                  updatePersonalDetails({
                    firstName: firstNameInputValue,
                    lastName: lastNameInputValue
                  })
                }
              >
                SAVE
              </RaisedButton>
            </div>
          </div>
        </Row>
        <Row>
          {/* EMAIL */}
          <div className="col-12 col-lg-4 mb-3">
            <p style={{fontSize: 22}}>
              {email}&nbsp;
              <FlatButton
                className="mx-3 d-inline"
                onClick={() => setEditingEmail(!editingEmail)}
              >
                EDIT
              </FlatButton>
            </p>
            <div hidden={!editingEmail}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                className="form-control mb-3"
                value={emailInputValue}
                onChange={event => setEmailInputValue(event.target.value)}
              />
              <RaisedButton
              className="btn-hover"
                onClick={() =>
                  updatePersonalDetails({ email: emailInputValue })
                }
              >
                SAVE
              </RaisedButton>
            </div>
            <FlatButton onClick={() => triggerPasswordReset()}>RESET PASSWORD</FlatButton>
          </div>
        </Row>

        <div className="d-flex mt-5">
          <h4>MY ADDRESSES</h4>
          <FlatButton
            className="mx-3 d-inline"
            onClick={() => setEditingAddress(!editingAddress)}
          >
            Add new address
          </FlatButton>
        </div>
        <hr />
        <Row>
          {addresses &&
            addresses.length > 0 &&
            addresses.map((address, id) => (
              <AddressBox
                size="col-12 col-md-3"
                key={address && address.id}
                {...address}
              />
            ))}
        </Row>
        <div hidden={!editingAddress}>
          <AddressEditForm saveAddress={saveAddress} toggleAddressForm={() => setEditingAddress(!editingAddress)} />
        </div>
        <h4 className="mt-5">MY Subscriptions</h4>
        <hr />
        <Row>
          {subscriptions &&
            subscriptions.length > 0 &&
            subscriptions.map(({subscription, startDate, endDate}, id) => (
              <SubscriptionItem
                readOnly={true}
                className="col-12 col-md-4"
                key={subscription && subscription.id}
                { ...subscription }
                subscriptions = {subscriptions}
                startDate = {startDate}
                endDate = {endDate} 
              />
            ))}
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch, ownProps) => ({
	successNotification: (message) => dispatch(actions.successNotification(message)),
	errorNotification: (message) => dispatch(actions.errorNotification(message)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);
